// MediaError codes are numeric constants on the interface, not an enum the DOM
// lib exposes, so they are spelled out here to keep the mapping readable.
const REASONS: Record<number, string> = {
  1: 'Playback was aborted.',
  2: 'A network error interrupted the stream.',
  3: "The audio stream is corrupt or couldn't be decoded.",
  4: "The file's format isn't supported by this browser.",
}

/** Human-readable reason for a failed <audio> load, with the browser's own
 * diagnostic appended — that detail is what identifies a mislabelled file. */
export function describeMediaError(err: MediaError | null | undefined): string {
  const reason = (err && REASONS[err.code]) ?? 'Playback failed for an unknown reason.'
  const detail = err?.message?.trim()
  return detail ? `${reason} (${detail})` : reason
}
